<template>
  <main class="price-history-page">
    <section class="soft-card table-panel">
      <div class="toolbar">
        <el-select v-model="priceType" placeholder="价格类型" size="small" clearable class="type-select" @change="onSearch">
          <el-option label="全部" value="" />
          <el-option label="供应商价格" value="SUPPLIER_MODEL" />
          <el-option label="客户价格" value="CUSTOMER_MODEL" />
        </el-select>
        <el-input
          v-model="searchQuery"
          placeholder="搜索模型、客户、操作人..."
          size="small"
          clearable
          class="search-input"
          @keyup.enter.native="onSearch" @clear="onSearch"
        />
        <el-button size="small" plain icon="el-icon-search" @click="onSearch">搜索</el-button>
      </div>
      <div class="desktop-only">
        <el-table :data="list" size="small" style="width: 100%">
          <el-table-column type="index" label="序号" width="60" :index="pageIndex" />
          <el-table-column label="类型" width="100">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.priceType === 'SUPPLIER_MODEL' ? 'info' : 'warning'">
                {{ scope.row.priceType === 'SUPPLIER_MODEL' ? '供应商' : '客户' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="模型" min-width="220">
            <template slot-scope="scope">
              <div class="model-cell">
                <span class="model-icon">
                  <img v-if="scope.row.modelIcon" :src="scope.row.modelIcon" :alt="scope.row.modelName" @error="scope.row.modelIcon = ''">
                  <span v-else>{{ modelAbbr(scope.row.modelName) }}</span>
                </span>
                <span class="model-name">{{ scope.row.modelName || '-' }}</span>
                <el-tag v-if="scope.row.modelType && scope.row.modelType !== 'TEXT'" size="mini" :type="modelTypeInfo(scope.row.modelType).tagType" style="margin-left:4px;">{{ modelTypeInfo(scope.row.modelType).label }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="hasCustomerData" label="客户" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.priceType === 'CUSTOMER_MODEL'">{{ scope.row.customerName || '-' }}</span>
              <span v-else class="muted-text">-</span>
            </template>
          </el-table-column>
          <el-table-column label="供应商" width="100">
            <template slot-scope="scope">{{ scope.row.supplierName || '-' }}</template>
          </el-table-column>
          <el-table-column label="变更前" min-width="280">
            <template slot-scope="scope">
              <div class="price-card">
                <div v-if="scope.row.modelType === 'IMAGE'" class="price-item">
                  <span class="price-badge output-badge">每张</span>
                  <el-tooltip :content="'¥ ' + formatPrice(scope.row.oldOutputPrice)" placement="top" :disabled="(scope.row.oldOutputPrice || '').toString().length <= 8">
                    <span class="price-val"><span class="yen">¥</span>{{ formatPrice(scope.row.oldOutputPrice) }}</span>
                  </el-tooltip>
                </div>
                <div v-else-if="scope.row.modelType === 'EMBEDDING' || scope.row.modelType === 'RERANK' || scope.row.modelType === 'ASR'" class="price-item">
                    <span class="price-badge input-badge">入</span>
                    <el-tooltip :content="'¥ ' + formatPrice(scope.row.oldInputPrice)" placement="top" :disabled="(scope.row.oldInputPrice || '').toString().length <= 8">
                      <span class="price-val"><span class="yen">¥</span>{{ formatPrice(scope.row.oldInputPrice) }}</span>
                    </el-tooltip>
                  </div>
                <template v-else>
                  <div class="price-item">
                    <span class="price-badge input-badge">入</span>
                    <el-tooltip :content="'¥ ' + formatPrice(scope.row.oldInputPrice)" placement="top" :disabled="(scope.row.oldInputPrice || '').toString().length <= 8">
                      <span class="price-val"><span class="yen">¥</span>{{ formatPrice(scope.row.oldInputPrice) }}</span>
                    </el-tooltip>
                  </div>
                  <div class="price-divider"></div>
                  <div class="price-item">
                    <span class="price-badge output-badge">出</span>
                    <el-tooltip :content="'¥ ' + formatPrice(scope.row.oldOutputPrice)" placement="top" :disabled="(scope.row.oldOutputPrice || '').toString().length <= 8">
                      <span class="price-val"><span class="yen">¥</span>{{ formatPrice(scope.row.oldOutputPrice) }}</span>
                    </el-tooltip>
                  </div>
                  <div class="price-divider"></div>
                  <div class="price-item">
                    <span class="price-badge cache-badge">缓</span>
                    <el-tooltip :content="'¥ ' + formatPrice(scope.row.oldCachePrice)" placement="top" :disabled="(scope.row.oldCachePrice || '').toString().length <= 8">
                      <span class="price-val"><span class="yen">¥</span>{{ formatPrice(scope.row.oldCachePrice) }}</span>
                    </el-tooltip>
                  </div>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="变更后" min-width="280">
            <template slot-scope="scope">
              <div class="price-card">
                <div v-if="scope.row.modelType === 'IMAGE'" class="price-item">
                  <span class="price-badge output-badge">每张</span>
                  <el-tooltip :content="'¥ ' + formatPrice(scope.row.newOutputPrice)" placement="top" :disabled="(scope.row.newOutputPrice || '').toString().length <= 8">
                    <span class="price-val"><span class="yen">¥</span>{{ formatPrice(scope.row.newOutputPrice) }}</span>
                  </el-tooltip>
                </div>
                <div v-else-if="scope.row.modelType === 'EMBEDDING' || scope.row.modelType === 'RERANK' || scope.row.modelType === 'ASR'" class="price-item">
                    <span class="price-badge input-badge">入</span>
                    <el-tooltip :content="'¥ ' + formatPrice(scope.row.newInputPrice)" placement="top" :disabled="(scope.row.newInputPrice || '').toString().length <= 8">
                      <span class="price-val"><span class="yen">¥</span>{{ formatPrice(scope.row.newInputPrice) }}</span>
                    </el-tooltip>
                  </div>
                <template v-else>
                  <div class="price-item">
                    <span class="price-badge input-badge">入</span>
                    <el-tooltip :content="'¥ ' + formatPrice(scope.row.newInputPrice)" placement="top" :disabled="(scope.row.newInputPrice || '').toString().length <= 8">
                      <span class="price-val"><span class="yen">¥</span>{{ formatPrice(scope.row.newInputPrice) }}</span>
                    </el-tooltip>
                  </div>
                  <div class="price-divider"></div>
                  <div class="price-item">
                    <span class="price-badge output-badge">出</span>
                    <el-tooltip :content="'¥ ' + formatPrice(scope.row.newOutputPrice)" placement="top" :disabled="(scope.row.newOutputPrice || '').toString().length <= 8">
                      <span class="price-val"><span class="yen">¥</span>{{ formatPrice(scope.row.newOutputPrice) }}</span>
                    </el-tooltip>
                  </div>
                  <div class="price-divider"></div>
                  <div class="price-item">
                    <span class="price-badge cache-badge">缓</span>
                    <el-tooltip :content="'¥ ' + formatPrice(scope.row.newCachePrice)" placement="top" :disabled="(scope.row.newCachePrice || '').toString().length <= 8">
                      <span class="price-val"><span class="yen">¥</span>{{ formatPrice(scope.row.newCachePrice) }}</span>
                    </el-tooltip>
                  </div>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="变更时间" width="170">
            <template slot-scope="scope">{{ $formatTime(scope.row.createdAt) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mobile-only list-cards">
        <div class="list-card" v-for="(row, idx) in list" :key="idx">
          <div class="card-header">
            <div class="model-cell" style="display:inline-flex;align-items:center;gap:8px;">
              <span class="model-icon" style="width:20px;height:20px;font-size:10px;">
                <img v-if="row.modelIcon" :src="row.modelIcon" :alt="row.modelName" @error="row.modelIcon = ''">
                <span v-else>{{ modelAbbr(row.modelName) }}</span>
              </span>
              <div>
                <div class="card-title">{{ row.modelName || '-' }}
                <el-tag v-if="row.modelType && row.modelType !== 'TEXT'" size="mini" :type="modelTypeInfo(row.modelType).tagType" style="margin-left:4px;">{{ modelTypeInfo(row.modelType).label }}</el-tag>
              </div>
                <div class="card-sub">{{ row.supplierName || '-' }} <template v-if="hasCustomerData && row.priceType === 'CUSTOMER_MODEL'">· {{ row.customerName }}</template></div>
              </div>
            </div>
            <el-tag size="mini" :type="row.priceType === 'SUPPLIER_MODEL' ? 'info' : 'warning'">
              {{ row.priceType === 'SUPPLIER_MODEL' ? '供应商' : '客户' }}
            </el-tag>
          </div>
          <div style="display:flex;gap:12px;margin-bottom:6px;">
            <div style="flex:1;">
              <div style="font-size:10px;color:rgba(255,255,255,.35);margin-bottom:4px;letter-spacing:.02em;">变更前</div>
              <div style="display:flex;gap:4px;flex-wrap:wrap;">
                <template v-if="row.modelType === 'IMAGE'">
                  <span style="font-size:11px;color:rgba(255,255,255,.5);"><span style="color:#f4b74f;">每张</span> ¥{{ formatPrice(row.oldOutputPrice) }}</span>
                </template>
                <template v-else-if="row.modelType === 'EMBEDDING' || row.modelType === 'RERANK' || row.modelType === 'ASR'">
                  <span style="font-size:11px;color:rgba(255,255,255,.5);"><span style="color:#32c8f5;">入</span> ¥{{ formatPrice(row.oldInputPrice) }}</span>
                </template>
                <template v-else>
                  <span style="font-size:11px;color:rgba(255,255,255,.5);"><span style="color:#32c8f5;">入</span> ¥{{ formatPrice(row.oldInputPrice) }}</span>
                  <span style="font-size:11px;color:rgba(255,255,255,.5);"><span style="color:#f4b74f;">出</span> ¥{{ formatPrice(row.oldOutputPrice) }}</span>
                  <span style="font-size:11px;color:rgba(255,255,255,.5);"><span style="color:#34c98f;">缓</span> ¥{{ formatPrice(row.oldCachePrice) }}</span>
                </template>
              </div>
            </div>
            <div style="width:1px;background:rgba(133,164,255,.1);"></div>
            <div style="flex:1;">
              <div style="font-size:10px;color:rgba(255,255,255,.35);margin-bottom:4px;letter-spacing:.02em;">变更后</div>
              <div style="display:flex;gap:4px;flex-wrap:wrap;">
                <template v-if="row.modelType === 'IMAGE'">
                  <span style="font-size:11px;color:var(--text);"><span style="color:#f4b74f;">每张</span> ¥{{ formatPrice(row.newOutputPrice) }}</span>
                </template>
                <template v-else-if="row.modelType === 'EMBEDDING' || row.modelType === 'RERANK' || row.modelType === 'ASR'">
                  <span style="font-size:11px;color:var(--text);"><span style="color:#32c8f5;">入</span> ¥{{ formatPrice(row.newInputPrice) }}</span>
                </template>
                <template v-else>
                  <span style="font-size:11px;color:var(--text);"><span style="color:#32c8f5;">入</span> ¥{{ formatPrice(row.newInputPrice) }}</span>
                  <span style="font-size:11px;color:var(--text);"><span style="color:#f4b74f;">出</span> ¥{{ formatPrice(row.newOutputPrice) }}</span>
                  <span style="font-size:11px;color:var(--text);"><span style="color:#34c98f;">缓</span> ¥{{ formatPrice(row.newCachePrice) }}</span>
                </template>
              </div>
            </div>
          </div>
          <div class="meta-row">
            <span>{{ $formatTime(row.createdAt) }}</span>
          </div>
        </div>
      </div>
      <el-pagination
        class="pagination-bar"
        layout="total, prev, pager, next"
        small
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="onPageChange"
      />
    </section>
  </main>
</template>

<script>
import { modelTypeInfo as mtInfo } from '../utils/format'
export default {
  name: 'PriceHistoryPage',
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      priceType: '',
      searchQuery: ''
    }
  },
  computed: {
    pageIndex() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    hasCustomerData() {
      return this.list.some(item => item.priceType === 'CUSTOMER_MODEL')
    }
  },
  mounted() {
    this.fetchHistory()
  },
  methods: {
    modelTypeInfo(type) {
      return mtInfo(type)
    },
    modelAbbr(name) {
      if (!name) return 'M'
      return name.substring(0, 2).toUpperCase()
    },
    formatPrice(value) {
      if (value == null || value === '') return '-'
      const num = Number(value)
      if (num === 0) return '0'
      return num.toFixed(6).replace(/\.?0+$/, '')
    },
    onPageChange(page) {
      this.currentPage = page
      this.fetchHistory()
    },
    onSearch() {
      this.currentPage = 1
      this.fetchHistory()
    },
    async fetchHistory() {
      try {
        const params = {}
        if (this.priceType) params.priceType = this.priceType
        if (this.searchQuery) params.keyword = this.searchQuery
        params.page = this.currentPage
        params.pageSize = this.pageSize
        const res = await this.$http.get('/admin/model-price-history', { params })
        this.list = res.records || []
        this.total = Number(res.total) || 0
      } catch {
        this.$message.error('加载价格历史失败')
      }
    }
  }
}
</script>

<style scoped>
.price-history-page {
  padding: 18px 24px 76px;
}

.table-panel {
  padding: 16px;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.table-panel ::v-deep .el-table,
.table-panel ::v-deep .el-table__header-wrapper,
.table-panel ::v-deep .el-table__body-wrapper {
  border-radius: var(--radius);
}

.table-panel ::v-deep th {
  background: rgba(255, 255, 255, 0.045);
  color: #9eb1ca;
  font-weight: 850;
}

.table-panel ::v-deep td,
.table-panel ::v-deep th {
  border-color: var(--line-soft);
}

.pagination-bar {
  margin-top: 20px;
  text-align: right;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
}

.search-input {
  width: 220px;
}

.type-select {
  width: 140px;
}

.muted-text {
  font-size: 12px;
  color: var(--muted-2);
}

.model-cell {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.model-icon {
  width: 26px;
  height: 26px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  overflow: hidden;
  color: var(--cyan);
  font-size: 12px;
  font-weight: 800;
  background: rgba(79, 134, 255, 0.14);
  border: 1px solid rgba(133, 164, 255, 0.16);
}

.model-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.model-name {
  font-weight: 700;
  color: var(--text);
}

.price-card {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid var(--line-soft);
  border-radius: var(--radius);
  padding: 6px 10px;
  gap: 0;
}

.price-item {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 0 2px;
  color: var(--text);
}

.price-divider {
  width: 1px;
  height: 20px;
  background: rgba(151, 171, 207, 0.18);
  flex: none;
}

.price-badge {
  font-size: 9px;
  font-weight: 700;
  padding: 0 4px;
  border-radius: 3px;
  line-height: 1.5;
  flex: none;
}

.input-badge {
  background: rgba(79, 134, 255, 0.14);
  color: #9fc0ff;
}

.output-badge {
  background: rgba(52, 201, 143, 0.12);
  color: #55f0b3;
}

.cache-badge {
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
}

.price-val {
  display: inline-block;
  max-width: 100%;
  font-family: 'SF Mono', 'Cascadia Code', 'Consolas', monospace;
  font-size: 12px;
  font-weight: 700;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.5;
}

.price-val .yen {
  color: #94a3b8;
  font-weight: 400;
  margin-right: 1px;
}

.list-cards {
  display: grid;
  gap: 14px;
}

.mobile-only { display: none; }

@media (max-width: 760px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }
  .price-history-page {
    padding: 12px 12px 28px;
  }
  .table-panel {
    padding: 10px;
    overflow-x: visible;
  }
  .toolbar {
    flex-wrap: wrap;
  }
  .search-input {
    flex: 1;
    min-width: 80px;
  }
  .type-select {
    width: 120px;
    flex: none;
  }
  .pagination-bar {
    text-align: center;
  }
}
.list-card {
  padding: 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(27,39,58,.92), rgba(20,30,46,.88));
  border: 1px solid rgba(133,164,255,.12);
  box-shadow: 0 8px 28px rgba(0,0,0,.22);
  overflow: hidden;
  transition: transform .18s ease, box-shadow .18s ease;
}
.list-card:active {
  transform: translateY(-1px);
  box-shadow: 0 12px 36px rgba(0,0,0,.3);
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 8px;
}
.card-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.3;
}
.card-sub {
  font-size: 12px;
  color: rgba(255,255,255,.4);
  margin-top: 2px;
}
.price-grid {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}
.price-cell {
  flex: 1;
  min-width: 0;
  text-align: center;
  padding: 8px 6px;
  border-radius: 8px;
  background: rgba(255,255,255,.04);
}
.price-cell .label {
  font-size: 10px;
  color: rgba(255,255,255,.35);
  letter-spacing: .02em;
}
.price-cell .value {
  font-size: 13px;
  font-weight: 700;
  color: var(--text);
  margin-top: 2px;
}
.price-cell .value.input { color: #32c8f5; }
.price-cell .value.output { color: #f4b74f; }
.price-cell .value.cache { color: #34c98f; }
.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
  font-size: 11px;
  color: rgba(255,255,255,.35);
}
.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
}
.card-actions .el-button--text {
  font-size: 12px;
  padding: 4px 10px;
  height: auto;
}

.price-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-family: 'SF Mono', 'Cascadia Code', 'Consolas', monospace;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.5;
}
.price-summary .price-badge {
  margin-right: 2px;
}
</style>
